import styled from "styled-components";

const NavStyle = styled.nav`
  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: center;
flex-wrap: wrap;
  margin-top: 1rem;
  font-family: "Wallpoet";
  font-size: 3rem;
  gap: 1rem;
`;

export default NavStyle;
